import {
  prepareImageFileDataUrl,
  validateImageFile,
} from "@/utils/image-upload";

export const validatePhotoFile = validateImageFile;
export const fileToDataUrl = prepareImageFileDataUrl;
